import React from 'react'
import { NavLink, useNavigate, useParams } from 'react-router-dom'

const AssociationInfoSideBar = () => {
    const { associationId } = useParams()
    const navigate = useNavigate()

    const goBack = () => {
        console.log(11);
        
        navigate('/app/associations')
    }

    return (
        // <!-- ========== App Menu ========== -->
        <div className="app-menu navbar-menu">
            {/* <!-- LOGO --> */}
            <div className="navbar-brand-box">
                {/* <!-- Dark Logo--> */}
                <NavLink to="/" className="logo logo-dark">
                    <span className="logo-sm">
                        <img src="/assets/innermember.png" alt="" height="22" />
                    </span>
                    <span className="logo-lg">
                        <img src="/assets/innermember.png" alt="" height="40"/>
                    </span>
                </NavLink>
                {/* <!-- Light Logo--> */}
                <NavLink to="/" className="logo logo-light">
                    <span className="logo-sm">
                        <img src="/assets/innermember-white.png" alt="" height="22" />
                    </span>
                    <span className="logo-lg">
                        <img src="/assets/innermember-white.png" alt="" height="40" />
                    </span>
                </NavLink>
                <button type="button" className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
                    id="vertical-hover">
                    <i className="ri-record-circle-line"></i>
                </button>
            </div>

            <div id="scrollbar">
                <div className="container-fluid">

                    <div id="two-column-menu">
                    </div>
                    <ul className="navbar-nav" id="navbar-nav">
                        <>
                            <li className="menu-title">
                               <span data-key="t-menu">Association Info</span>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link menu-link" to={`/app/associations/${associationId}`}>
                                    <i className="ri-dashboard-2-line"></i> <span data-key="t-widgets">Dashboard</span>
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link menu-link" to={`/app/associations/${associationId}/membership`}>
                                    <i className="ri-file-shield-line"></i> <span data-key="t-widgets">Membership</span>
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link menu-link" to={`/app/associations/${associationId}/dues`}>
                                    <i className="ri-money-pound-circle-line"></i> <span data-key="t-widgets">Dues</span>
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link menu-link" to={`/app/associations/${associationId}/forum`}>
                                    <i className="ri-chat-1-line"></i> <span data-key="t-widgets">Forum</span>
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link menu-link" to={`/app/associations/${associationId}/events`}>
                                    <i className="ri-calendar-event-line"></i> <span data-key="t-widgets">Events</span>
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link menu-link" to={`/app/associations/${associationId}/meetings`}>
                                    <i className="ri-file-list-line"></i> <span data-key="t-widgets">Meetings</span>
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link menu-link" to={`/app/associations/${associationId}/news`}>
                                    <i className="ri-newspaper-line"></i> <span data-key="t-widgets">News</span>
                                </NavLink>
                            </li>
                            <div className="text-center mt-3" >
                                <NavLink to={'/app/associations'} className="btn btn-outline-danger waves-effect waves-light">
                                    <i className=' bx bx-arrow-back me-1'></i>
                                    Back
                                </NavLink>
                            </div>
                        </>
                    </ul>
                </div>
                {/* <!-- Sidebar --> */}
            </div>

            <div className="sidebar-background"></div>
        </div>
    )
}

export default AssociationInfoSideBar
